<template>
    <div>
        <vue-element-loading :active="show" spinner="ring" color="#006db3" size="128" text="กรุณารอสักครู่..." is-full-screen/>
        <!-- <h1><i class="text-black-50 fa fa-cogs" aria-hidden="true"></i> จัดการฟอร์ม</h1> -->
        <NavBar></NavBar>
        <div class="container">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <button type="button" class="btn btn-light btn-lg pull-right" @click="openModal('สร้าง')">
                        <i class="fa fa-plus-circle fa-lg text-success" aria-hidden="true"></i> สร้างผู้ใช้งาน
                    </button>
                </div>
            </div>

            <table class="table table-hover mt-2" style="background-color: #fff;">
                <thead>
                    <tr>
                        <th v-for="(item, index) in thead" :key="index" scope="col" :class="item.class" :style="item.style">{{ item.name }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in tbody" :key="index">
                        <th scope="row" >{{ index+1 }}</th>
                        <td>{{ item.company_id }}</td>
                        <td>{{ item.role_id }}</td>
                        <td >{{ item.id }}</td>
                        <td >{{ item.name }}</td>
                        <td >{{ item.last_name }}</td>
                        <td v-if="item.role_id!='admin'" class="text-center">
                            <button type="button" class="btn btn-light mr-2" title="ลบ" @click="validatedCancelUser(item)"><i class="fa fa-trash fa-lg text-danger" aria-hidden="true"></i></button>
                            <button type="button" class="btn btn-light" title="แก้ไข" @click="edit(item)"><i class="fa fa-pencil fa-lg text-primary" aria-hidden="true"></i></button>
                        </td>
                        <td v-else></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ModalCenter :open="isOpen" :title="title+' Line channel token'" :styleModalHeader="{'background': '#fefefe', 'color': '#212529'}" @close="closeModal">
            <template v-slot:content>
                <form :class="validated ? 'was-validated':''">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <label for="company" class="mb-0">รหัสโรงงาน</label>
                            <select id="company" :class="'form-control '+(validated ? 'was-validated':'')" v-model="companyId" required>
                                <option value="" disabled class="text-black-50">กรุณาเลือกสิทธ์</option>
                                <option v-for="(item,index) in listCompany" :key="index" :value="item.id">{{ item.id }} - {{ item.name_th }}</option>
                            </select>
                            <div class="invalid-feedback m-0">กรุณากรอกข้อมูล</div>
                        </div>
                    </div>

                    <div class="row mt-2 mb-2">
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <label for="role" class="mb-0">เลือกสิทธ์</label>
                            <select id="role" :class="'form-control '+(validated ? 'was-validated':'')" v-model="roleId" required>
                                <option value="" disabled class="text-black-50">กรุณาเลือกสิทธ์</option>
                                <option v-for="(item,index) in listRole" :key="index" :value="item.id">{{ item.name }}</option>
                            </select>
                            <div class="invalid-feedback m-0">กรุณากรอกข้อมูล</div>
                        </div>

                        <div v-if="title!='แก้ไข'" class="col-xl-6 col-lg-6 col-md-6">
                            <label for="name" class="mb-0">รหัสพนักงาน</label>
                            <input type="text" :class="'form-control '+(validated ? 'was-validated':'')" v-model="userId" @focus="onFocus" placeholder="รหัสพนักงาน" required>
                            <div class="invalid-feedback m-0">กรุณากรอกข้อมูล</div>
                        </div>
                    </div>

                    <div class="row mt-2 mb-2">
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <label for="name" class="mb-0">ชื่อ</label>
                            <input type="text" :class="'form-control '+(validated ? 'was-validated':'')" v-model="name" @focus="onFocus" placeholder="ชื่อ" required>
                            <div class="invalid-feedback m-0">กรุณากรอกข้อมูล</div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <label for="name" class="mb-0">นามสกุล</label>
                            <input type="text" :class="'form-control '+(validated ? 'was-validated':'')" v-model="lastName" @focus="onFocus" placeholder="นามสกุล" required>
                            <div class="invalid-feedback m-0">กรุณากรอกข้อมูล</div>
                        </div>
                    </div>

                    <div class="row mt-2 mb-2">
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <label for="name" class="mb-0">USERNAME</label>
                            <input type="text" :class="'form-control '+(validated ? 'was-validated':'')" v-model="username" @focus="onFocus" placeholder="USERNAME" required>
                            <div class="invalid-feedback m-0">กรุณากรอกข้อมูล</div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <label for="name" class="mb-0">PASSWORD</label>
                            <input type="password" :class="'form-control '+(validated ? 'was-validated':'')" v-model="password" @focus="onFocus" placeholder="PASSWORD" required>
                            <div class="invalid-feedback m-0">กรุณากรอกข้อมูล</div>
                        </div>
                    </div>

                </form>
            </template>
            <template v-slot:footer>
                <button type="button" class="btn btn-success" @click="validatedUser">{{ title }}</button>
            </template>
        </ModalCenter>

    </div>
</template>

<script>
import Vue from 'vue';
import Api from './../api';

import NavBar from '@/components/NavBar';
import ModalCenter from '@/components/ModalCenter';
export default {
    components:{
        NavBar,
        ModalCenter
    },

    data(){
        return {
            user: null,
            show: false,
            validated: false,
            thead: [
                { name: '#', style:{ width: '2%' } },
                { name: 'รหัสโรงงาน', style:{ width: '10%' }  },
                { name: 'สิทธิ์การใช้งาน', style:{ width: '10%' } },
                { name: 'รหัสพนักงาน', style:{ width: '10%' } },
                { name: 'ชื่อ', style:{ width: '10%' }  },
                { name: 'นามสกุล', style:{ width: '10%' } },
                { name: 'จัดการ', class: 'text-center', style:{ width: '8%' } },
            ],
            tbody: [],

            isOpen: false,
            title: '',
            userId: '',
            
            companyId: '',
            listCompany: [],

            roleId: '',
            listRole: [],

            name: '',
            lastName: '',
            username: '',
            password: ''

        }
    },

    created(){
        this.user = this.$store.state.user;
        this.getUserActiveAll();
        this.getRoleActiveAll();
        this.getCompanyActiveAll();
    },

    watch: {

    },

    methods:{
        onFocus(event) {
            event.target.select();
        },

        getCompanyActiveAll(){
            this.show = true;
            this.listCompany = [];
            Api.getCompanyActiveAll().then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.listCompany = data.result;
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        getRoleActiveAll(){
            this.show = true;
            this.listRole = [];
            Api.getRoleActiveAll().then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.listRole = data.result;
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        getUserActiveAll(){
            this.show = true;
            Api.getUserActiveAll().then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.tbody = data.result;
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        intialValue(){
            this.userId = "";
            this.title = "";
            this.companyId = "";
            this.roleId = "";
            this.name = "";
            this.lastName = "";
            this.username = "";
            this.password = "";
        },

        edit(obj){
            this.userId = obj.id;
            this.companyId = obj.company_id;
            this.roleId = obj.role_id;
            this.name = obj.name;
            this.lastName = obj.last_name;
            this.username = obj.username;
            this.password = obj.password;
            this.openModal('แก้ไข');
        },

        openModal(title) { 
            this.isOpen = true;
            this.title = title;
        },

        closeModal() {
            this.isOpen = false;
            this.intialValue();
        },

        validatedUser(){
            this.validated = true;
            if(this.userId!='' && this.companyId!='' && this.roleId!='' && this.name!='' && this.lastName!='' && this.username!='' && this.password!=''){
                this.validated = false;
                if(this.title=='สร้าง'){
                    this.saveUser();
                }else if(this.title=='แก้ไข'){
                    this.updateUser();
                }
            }else{
                this.$swal('กรุณากรอกข้อมูล!', '', "warning");
            }
        },

        saveUser(){
            this.show = true;
            var body = {
                userId: this.userId,
                companyId: this.companyId,
                roleId: this.roleId,
                name: this.name,
                lastName: this.lastName,
                username: this.username,
                password: this.password
            };
            Api.saveUser(body).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.$swal(data.message, '', "success");
                    this.closeModal();
                    this.getUserActiveAll();
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        updateUser(){
            this.show = true;
            var token = this.user.token;
            var body = {
                userId: this.userId,
                companyId: this.companyId,
                roleId: this.roleId,
                name: this.name,
                lastName: this.lastName,
                username: this.username,
                password: this.password
            };
            Api.updateUser(token,body).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.$swal(data.message, '', "success");
                    this.closeModal();
                    this.getUserActiveAll();
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        validatedCancelUser(obj){
            this.$swal({
                title: 'ต้องการลบรหัสพนักงาน '+obj.id,
                text: "ตรวจสอบข้อมูลให้แน่ใจก่อนยืนยัน",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                if (result.isConfirmed) {
                    this.cancelUser(obj);
                }
            })
        },

        cancelUser(obj){
            this.show = true;
            var token = this.user.token;
            var body = {
                id: obj.id,
            };
            Api.cancelUser(token,body).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.$swal(data.message, '', "success");
                    this.getUserActiveAll();
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },
    }
}
</script>

<style scoped>
    #create-form {
        border: 1px solid rgba(0, 0, 0, 0.125);
    }

    td.ellipsis {
        white-space: nowrap; 
        width: 5px; 
        overflow: hidden;
        text-overflow: ellipsis; 
    }

    table {
        table-layout: fixed;
        width: 100%;
    }
    td {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

</style>